import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";
import { Map, MapMarker } from "react-kakao-maps-sdk";
import ScrollOut from "scroll-out";

const mapLocation = {
    본사: {
        lat: 37.48851478043307,
        lng: 127.09880822088527
    },
    품질지원센터: {
        lat: 37.4806659989658,
        lng: 126.903579549859
    },
    강북본부: {
        lat: 37.6246541800923,
        lng: 127.028501814297
    },
    강남본부: {
        lat: 37.5114789118524,
        lng: 126.934349456746
    },
    강서본부: {
        lat: 37.393481604742,
        lng: 126.954284712088
    },
    강원본부: {
        lat: 37.3532748736974,
        lng: 127.947292776895
    }
};

const Direction = () => {
    const [lat, setLat] = useState(mapLocation["본사"].lat);
    const [lng, setLng] = useState(mapLocation["본사"].lng);

    useEffect(() => {
        ScrollOut({
            threshold: 0.3,
            once: true
        });
        // //         // 주소-좌표 변환 객체를 생성합니다
        // var geocoder = new window.kakao.maps.services.Geocoder();

        // // // 주소로 좌표를 검색합니다
        // geocoder.addressSearch("서울시 동작구 대방동 45-14 KT동작지사 3층", function (result, status) {
        //     // 정상적으로 검색이 완료됐으면
        //     if (status === window.kakao.maps.services.Status.OK) {
        //         console.log("result[0].y", result[0].y);
        //         console.log("result[0].x", result[0].x);
        //     }
        // });
    }, []);

    const changLocationMap = name => {
        setLat(mapLocation[name].lat);
        setLng(mapLocation[name].lng);
    };

    return (
        <>
            <SubHead title="오시는 길" eng="LOCATION"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <div className="direction-top-infos" data-scroll>
                        <div className="title">
                            <h2>주소 및 연락처</h2>
                            <h3>ktMOS 북부 본사</h3>
                        </div>
                        <div className="infos">
                            <div className="col address" onClick={() => changLocationMap("본사")}>
                                <p>
                                    서울시 강남구 광평로47길 28 KT수서빌딩 1층, 5층
                                    <span className="blocks">
                                        수서역 1-1 출구에서 220m 보도 이동 <br />
                                        (수서역 공용주차장 건너편)
                                    </span>
                                </p>
                            </div>
                            <div className="col phone">
                                <p>02-703-5751</p>
                            </div>
                            <div className="col fax">
                                <p>02-703-5754</p>
                            </div>
                        </div>
                    </div>

                    <div className="direction-map" data-scroll>
                        {/* <p>지도 넣는 곳</p> */}
                        <Map center={{ lat, lng }} style={{ width: "100%", height: "100%" }}>
                            <MapMarker position={{ lat, lng }}>{/* <div style={{ color: "#000", textAlign: "center" }}>ktMOS북부</div> */}</MapMarker>
                        </Map>
                    </div>

                    <ul className="direct-map-add-list">
                        <li onClick={() => changLocationMap("품질지원센터")}>
                            <b>품질지원센터</b> : 서울특별시 관악구 조원중앙로 1길 26, kt구로빌딩 5층
                        </li>
                        <li onClick={() => changLocationMap("강북본부")}>
                            <b>강북본부</b> : 서울특별시 강북구 솔매로50길 43, kt미아빌딩 3층
                        </li>
                        <li onClick={() => changLocationMap("강남본부")}>
                            <b>강남본부</b> : 서울시 동작구 대방동 45-14 KT동작지사 2층
                        </li>
                        <li onClick={() => changLocationMap("강서본부")}>
                            <b>강서본부</b> : 경기도 안양시 동안구 비산동 1110-3, kt안양빌딩 4층
                        </li>
                        <li onClick={() => changLocationMap("강원본부")}>
                            <b>강원본부</b> : 강원도 원주시 학성동 213-11, kt학성빌딩 2층
                        </li>
                    </ul>
                </div>
            </main>
        </>
    );
};

export default Direction;
